<app-collapsible-container
    [id]="'schoolStripe'"
    [title]="'REPERTOIRE.FORMS.STRIPE.TITLE'"
    [icon]="'i-credit-card'"
    (elementSizeModification)="elementSizeModification.emit()"
>
    <!-- Secret Key -->
    <div class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.STRIPE.LABEL1' | translate }}*</label>
        <app-sensitive-input
            *ngIf="secretKey"
            [formControl]="secretKey"
            [inputConfig]="{
                placeholder: 'REPERTOIRE.FORMS.STRIPE.PHD1',
                inputId: 'secretKey',
                type: basicInputTypeEnum.TEXT
            }"
            [isValid]="secretKey.valid"
            [isEdit]="!stripeSettings?.secret_key_present"
        >
            <app-form-errors
                *ngIf="secretKey.touched"
                [errors]="secretKey.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-sensitive-input>
    </div>
    <!-- Publishable Key -->
    <div class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.STRIPE.LABEL2' | translate }}*</label>
        <app-basic-input
            *ngIf="publishableKey"
            [formControl]="publishableKey"
            [inputConfig]="{
                placeholder: 'REPERTOIRE.FORMS.STRIPE.PHD2',
                inputId: 'publishableKey',
                type: basicInputTypeEnum.TEXT
            }"
            [isValid]="publishableKey.valid"
        >
            <app-form-errors
                *ngIf="publishableKey.touched"
                [errors]="publishableKey.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>
    <!-- Webhook Secret -->
    <div class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.STRIPE.LABEL3' | translate }}*</label>
        <app-sensitive-input
            *ngIf="webhookSigningSecret"
            [formControl]="webhookSigningSecret"
            [inputConfig]="{
                placeholder: 'REPERTOIRE.FORMS.STRIPE.PHD3',
                inputId: 'webhookSigningSecret',
                type: basicInputTypeEnum.TEXT
            }"
            [isValid]="webhookSigningSecret.valid"
            [isEdit]="!stripeSettings?.webhook_signing_secret_present"
        >
            <app-form-errors
                *ngIf="webhookSigningSecret.touched"
                [errors]="webhookSigningSecret.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-sensitive-input>
    </div>
</app-collapsible-container>
